import { HttpMethods, RequestPerformer } from '@/api/api-requests-factory';
import { Ref } from 'vue';
import GetCountryListRequest from '@/api/dictionary/country-list.request';
import GetCurrencyListRequest from '@/api/dictionary/currency-list-request';
import GetGameTypeListRequest from '@/api/dictionary/game-type-list-request';
import GetGameCategoryListRequest from '@/api/dictionary/game-category-list.request';

export class DictionaryApiResources {
  public constructor(
    private readonly requestPerformer: RequestPerformer,
    private readonly apiUrl: Ref<string>,
    private readonly multibrandApiUrl: Ref<string>,
  ) {}

  public get getCountryListRequest(): GetCountryListRequest {
    return new GetCountryListRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/dictionary/country`,
      HttpMethods.GET,
    );
  }

  public get getCurrencyListRequest(): GetCurrencyListRequest {
    return new GetCurrencyListRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/dictionary/currency`,
      HttpMethods.GET,
    );
  }

  public get getGameTypeListRequest(): GetGameTypeListRequest {
    return new GetGameTypeListRequest(
      this.requestPerformer,
      `${this.multibrandApiUrl.value}/dictionary/gameType`,
      HttpMethods.GET,
    );
  }

  public get getGameCategoryListRequest(): GetGameCategoryListRequest {
    return new GetGameCategoryListRequest(
      this.requestPerformer,
      `${this.apiUrl.value}/dictionary/gameCategory`,
      HttpMethods.GET,
    );
  }
}
